(function(angular) {
    'use strict';

    angular.module('aprima-core').filter('hasKeys', [
        '_',
        hasKeysFactory,
    ]);

    function hasKeysFactory(
        _
    ) {

        return hasKeys;


        function hasKeys(input) {
            var keys = _.keys(input);
            return keys && keys.length;
        }
    }

})(window.angular);